import { useState, useContext, useRef } from "react";
import * as Constants from "../../../../../utils/constants"
import { useEditorFile } from "../../../../../hooks/useEditorFile";
import { useDynamicTableRows } from "../../../../../hooks/useDynamicTableRows";
import { DxmlBreakTableBodyContext, WebEditorContext, PageElementContext } from "../../../../../contexts";
import { BarsArrowDownIcon, BarsArrowUpIcon, TrashIcon, ArrowUpIcon, ArrowDownIcon } from "@heroicons/react/24/outline";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../../../../translations/translationsConstants";
import DxmlElements from "../DxmlElements";

export default function DxmlBreakTableBody({ editorBreakTableBody }) {
    const { t: te } = useTranslation([resources.edit]);
    const { autoSaveEditorFile, editorFileRef } = useContext(WebEditorContext);
    const editorFileManager = useEditorFile();
    const dynamicTableRows = useDynamicTableRows();
    const rightClickTableIdRef = useRef();
    const { handleContextMenu: handlePageElementContextMenu } = useContext(PageElementContext) || {};

    const handleInsertRowAbove = () => {
        dynamicTableRows.insertRowAbove(rightClickTableIdRef.current, editorBreakTableBody, editorFileRef.current, editorFileManager);
        autoSaveEditorFile();
        rightClickTableIdRef.current = null;
    }

    const handleInsertRowBelow = () => {
        dynamicTableRows.insertRowBelow(rightClickTableIdRef.current, editorBreakTableBody, editorFileRef.current, editorFileManager);
        autoSaveEditorFile();
        rightClickTableIdRef.current = null;
    }

    const handleDeleteRow = () => {
        dynamicTableRows.deleteRow(rightClickTableIdRef.current, editorBreakTableBody);
        autoSaveEditorFile();
        rightClickTableIdRef.current = null;
    }

    const handleMoveUpRow = () => {
        dynamicTableRows.moveUpRow(rightClickTableIdRef.current, editorBreakTableBody);
        autoSaveEditorFile();
        rightClickTableIdRef.current = null;
    }

    const handleMoveDownRow = () => {
        dynamicTableRows.moveDownRow(rightClickTableIdRef.current, editorBreakTableBody);
        autoSaveEditorFile();
        rightClickTableIdRef.current = null;
    }

    const menuItems = [
        [
            {
                label: te(translations.edit.breakTable.insertRowAbove),
                icon: <BarsArrowUpIcon />,
                onClick: () => handleInsertRowAbove(rightClickTableIdRef.current),
            },
            {
                label: te(translations.edit.breakTable.insertRowBelow),
                icon: <BarsArrowDownIcon />,
                onClick: () => handleInsertRowBelow(rightClickTableIdRef.current),
            },
            {
                label: te(translations.edit.breakTable.deleteRow),
                icon: <TrashIcon />,
                onClick: () => handleDeleteRow(rightClickTableIdRef.current),
            },
            {
                label: te(translations.edit.breakTable.moveUp),
                icon: <ArrowUpIcon />,
                onClick: () => handleMoveUpRow(rightClickTableIdRef.current),
            },
            {
                label: te(translations.edit.breakTable.moveDown),
                icon: <ArrowDownIcon />,
                onClick: () => handleMoveDownRow(rightClickTableIdRef.current),
            },
        ]
    ];

    const handleContextMenu = (e, editorTable) => {
        if (!editorBreakTableBody || !editorBreakTableBody.WriteEnabled)
            return;

        e.preventDefault();

        rightClickTableIdRef.current = editorTable.Id;

        let extraMenuItems = menuItems;
        if (e.extraMenuItems?.length > 0) {
            extraMenuItems = extraMenuItems.concat(e.extraMenuItems);
        }
        e.extraMenuItems = extraMenuItems;
    }

    return editorBreakTableBody && (
        <>
            <DxmlBreakTableBodyContext.Provider value={{
                handleContextMenu: handleContextMenu,
            }}>
                <DxmlElements editorBaseModel={editorBreakTableBody} />
            </DxmlBreakTableBodyContext.Provider>
        </>
    )
}